import React, { useState } from 'react';
import Params from '../../../../../Types/ParamsPicklist';
import { Box, Grid } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import Datas from '../../../../../Data/Data.json';
import SelectMultipleOptionPanier from '../../../../SelectMultipleOptionPanier';
import { Spin } from 'antd';

let searchOperat: Params = { CodeAgence: '', Table: 'OPERAT', Colonne1: 'CODOPE', Colonne2: 'LIBELL', Colagence: '101', Choix: 22 };

function Tab3(props: { form?: any }) {
  const authHeader = useAuthHeader();
  const [loading, setLoading] = useState(false);

  return (
    <div className='tabItem'>
      <div>
        <Box fontStyle='inherit' className='border' width={'85%'} position={'absolute'}>
          <Grid item xs={12} md={12} lg={12}>
            <SelectMultipleOptionPanier notRequired disabled form={props.form} Size='large' width={4} label='Frais de gestion' name='CodeFrais' Parametre={searchOperat} />
          </Grid>
        </Box>
      </div>
    </div>
  );
}

export default Tab3;
